import { PROJECT_STATUS } from "@/enums";
import { IProjectStatus } from "@/interfaces";

export const buildProjectStatusOptions = (): IProjectStatus[] => [
  ...buildOptions(PROJECT_STATUS.intake),
  ...buildOptions(PROJECT_STATUS.project),
];

const buildOptions = (statuses: {
  [key: string]: IProjectStatus;
}): IProjectStatus[] =>
  Object.keys(statuses).map((name) => {
    const { id, translationId } = statuses[name];

    return {
      id,
      translationId,
    };
  });
